<script>
  import Landing from "./pages/Landing.svelte";
  import RegionSelection from "./pages/RegionSelection.svelte";
  import CategorySelection from "./pages/CategorySelection.svelte";
  import Redirect from "./pages/Redirect.svelte";
  import { step } from "./stores";
  import Questions from "./pages/Questions.svelte";
</script>

{#if $step === 99}
  <Questions />
{:else if $step === 0}
  <Landing />
{:else if $step === 1}
  <RegionSelection />
{:else if $step === 2}
  <CategorySelection />
{:else if $step === 3}
  <Redirect />
{/if}

<style>
  :global(body) {
    padding: 0;
  }

  :global(.container) {
    max-width: 700px;
    margin: 0 auto;
    padding: 0 16px;
    box-sizing: border-box;
    text-align: center;
  }

  :global(.buttons) :global(path) {
    fill: #c0fbd6;
    stroke: #000;
    transition: fill 0.3s ease, stroke 0.3s ease, stroke-width 0.3s ease;
  }

  :global(.buttons) :global(button:hover) :global(path) {
    stroke-width: 5px;
    stroke: #86af95;
    fill: #fcfcfc;
  }

  :global(img) {
    max-width: 100%;
  }
</style>
